import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmDialogProps {
  open: boolean;
  onClose: (confirmed: boolean) => void;
  title?: string;
  content?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  title = "Confirmation",
  content = "Are you sure you want to proceed?",
}) => {
  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth maxWidth="xs">
      <DialogTitle
        style={{
          backgroundColor: "var(--primary-color)",
          color: "var(--aggrid-text-color)",
          fontSize: "16px",
          fontWeight: "bolder",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.5em 1em"
        }}
      >
        {title}
        <IconButton
          data-testid="confirm-dialog-close-button"
          edge="end"
          color="inherit"
          onClick={() => onClose(false)}
          style={{
            color: "var(--aggrid-text-color)",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bold" }}
      >
        {content}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(true)}
          color="primary"
          style={{
            fontSize: "15px",
            color: "var(--aggrid-text-color)",
            backgroundColor: "var(--primary-color)",
            marginBottom: "1.25em"
          }}
        >
          Yes
        </Button>
        <Button
          onClick={() => onClose(false)}
          color="primary"
          style={{
            fontSize: "15px",
            color: "var(--aggrid-text-color)",
            backgroundColor: "var(--primary-color)",
            marginBottom: "1.25em"
          }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
